<script lang="ts" setup>
import { homeConfig as config } from './configs/vowpath'
import { useHomePage } from './composables/useHomePage'
import HomePageVowpath from './components/HomePage.vowpath.vue'

const HomePage = HomePageVowpath

// 🔥 使用 composable 管理页面逻辑
const {
  setInfiniteRef,
  input,
  inputFocused,
  pageList,
  pageInfo,
  skeleton,
  modules,
  currentTagId,
  feeds,
  feedShowName,
  feedId,
  feedsColumnType,
  feedFetching,
  feedEnding,
  homeBgUrl,
  switchNavTrack,
  onSearch,
  gotoCollection,
  gotoTags,
  gotoBook,
  getCurrentTagResources,
  getCurrentShowTags,
  handleTagClick,
  setInputRef,
} = useHomePage(config)
</script>

<template>
  <HomePage
    :config="config"
    :set-infinite-ref="setInfiniteRef"
    :set-input-ref="setInputRef"
    :input="input"
    :input-focused="inputFocused"
    :page-list="pageList"
    :page-info="pageInfo"
    :skeleton="skeleton"
    :modules="modules"
    :current-tag-id="currentTagId"
    :feeds="feeds"
    :feed-show-name="feedShowName"
    :feed-id="feedId"
    :feeds-column-type="feedsColumnType"
    :feed-fetching="feedFetching"
    :feed-ending="feedEnding"
    :home-bg-url="homeBgUrl"
    :switch-nav-track="switchNavTrack"
    :on-search="onSearch"
    :goto-collection="gotoCollection"
    :goto-tags="gotoTags"
    :goto-book="gotoBook"
    :get-current-tag-resources="getCurrentTagResources"
    :get-current-show-tags="getCurrentShowTags"
    :handle-tag-click="handleTagClick"
    @update:input="input = $event"
  />
</template>
